import { CardLoader } from 'components/organisms'
import withLoader from 'hocs/with-loader'
import { Table } from 'reactstrap'
import PropTypes from 'prop-types'

const propTypes       = {
  size: PropTypes.shape({
    id                     : PropTypes.number,
    label                  : PropTypes.string,
    product_size_filter_id : PropTypes.number,
    status                 : PropTypes.string,
    gender                 : PropTypes.string,
    applicable_for         : PropTypes.string
  })
}
const ProductSizeView = ({ size }) => (
  <Table size='sm' bordered>
    <thead>
      <tr>
        <th colSpan={ 2 } className='small text-uppercase font-weight-bold'>
          { 'Size' }
        </th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>id</td>
        <td>{ size.id }</td>
      </tr>
      <tr>
        <td>label</td>
        <td>{ size.label }</td>
      </tr>
      <tr>
        <td>product_size_filter_id</td>
        <td>{ size.product_size_filter_id }</td>
      </tr>
      <tr>
        <td>status</td>
        <td>{ size.status }</td>
      </tr>
      <tr>
        <td>gender</td>
        <td>{ size.gender }</td>
      </tr>
      <tr>
        <td>applicable_for</td>
        <td>{ size.applicable_for }</td>
      </tr>
    </tbody>
  </Table>

)

ProductSizeView.propTypes = propTypes

export default withLoader(ProductSizeView, CardLoader)